/**
 *
 * Select Field
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { Label, FormGroup } from "reactstrap"
import Select from "react-select"
import "./styles.scss"

function FilterSelectField(props) {
  const {
    label,
    name,
    value,
    onChange,
    isInvalid,
    metaData,
    options = [],
    required,
    labelClass,
    disabled,
  } = props
  const selectOptions =
    options && Array.isArray(options)
      ? options
      : typeof options === "string" &&
        metaData &&
        metaData[options] &&
        metaData[options].length > 0
      ? metaData[options]
      : []
  const isOptions =
    (selectOptions &&
      selectOptions.length > 0 &&
      selectOptions.find((_) => _.options) &&
      selectOptions.reduce((a, el) => {
        return [...a, ...el.options]
      }, [])) ||
    false

  const customStyles = {
    menu: (base) => ({
      ...base,
      opacity: 2,
      position: "absolute",
      zIndex: 9999,
    }),
  }
  const menuPortalTarget = document.getElementById('root')

  return (
    <React.Fragment>
      <FormGroup className="no-margin">
        <Label className={labelClass} htmlFor={name}>
          {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </Label>
        <Select
          name={name}
          value={
            isOptions && value
              ? isOptions.find((_) => _.value.toString() === value.toString())
              : selectOptions && selectOptions.length > 0 && value
              ? selectOptions.find(
                  (_) => _.value.toString() === value.toString()
                )
              : false
          }
          onChange={onChange}
        //   maxMenuHeight={250}
          menuPlacement="auto"
        //   menuPosition="relative"
          isDisabled={disabled}
          options={selectOptions}
          className={
            isInvalid
              ? "select2-error"
              : disabled === true
              ? "disabled-select-button"
              : null
          }
          classNamePrefix="select2-selection"
          invalid={isInvalid ? true : false}
          styles={customStyles}
          menuPortalTarget={menuPortalTarget}
        />
      </FormGroup>
    </React.Fragment>
  )
}

FilterSelectField.propTypes = {
  t: PropTypes.any,
  label: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  isInvalid: PropTypes.any,
  metaData: PropTypes.object,
  options: PropTypes.any,
  required: PropTypes.any,
  disabled: PropTypes.any,
  labelClass: PropTypes.any,
}

export default FilterSelectField
